import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { getCommonTeams } from 'components/FormFields/utils';
export function checkForOwningTeamError(_ref) {
  var _ref$isMultiSelect = _ref.isMultiSelect,
    isMultiSelect = _ref$isMultiSelect === void 0 ? false : _ref$isMultiSelect,
    audience = _ref.audience,
    ownerTeamIds = _ref.ownerTeamIds,
    teamIdsToRemove = _ref.teamIdsToRemove,
    audienceTeams = _ref.audienceTeams;
  var actualOwnerTeamIds = ownerTeamIds.filter(Boolean);
  if (actualOwnerTeamIds.length === 0) {
    return false;
  }
  if (audience === 'admin') {
    return true;
  }
  if (audience === 'all') {
    return false;
  }
  var areOwningTeamsAllSame = ownerTeamIds.every(function (ownerTeamId) {
    return ownerTeamId === ownerTeamIds[0];
  });
  if (areOwningTeamsAllSame || !isMultiSelect) {
    var commonTeams = isMultiSelect ? getCommonTeams(audienceTeams.map(function (teamList) {
      return teamList.filter(function (team) {
        return team.id !== 'null';
      });
    }).filter(function (teamList) {
      return teamList.length > 0;
    })) : audienceTeams[0];
    var selectableTeamIds = commonTeams === null || commonTeams === void 0 ? void 0 : commonTeams.filter(function (team) {
      return !(team !== null && team !== void 0 && team.isCalculated);
    }).map(function (team) {
      return team.id;
    });
    if (!actualOwnerTeamIds.every(function (teamId) {
      return selectableTeamIds.includes(teamId);
    })) {
      return true;
    }
  }
  if (teamIdsToRemove.length === 0) {
    return false;
  }
  // Check if owner team is being removed
  return teamIdsToRemove.some(function (teamId) {
    return actualOwnerTeamIds.includes(teamId);
  });
}
export default checkForOwningTeamError;